import { Reveal, SectionHeader } from "./shared";
import { about } from "../../data/portfolioData";

export const AboutSection = () => (
  <section id="about" className="py-20 lg:py-28 bg-[#090C13]" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20 items-start">
        <Reveal>
          <div className="relative lg:sticky lg:top-28">
            <div className="relative overflow-hidden rounded-3xl border border-white/[0.08]">
              <img
                src={about.portrait}
                alt="Vishal Behera — software engineer at work"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover opacity-90"
                data-testid="about-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#090C13] via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 glass-card rounded-2xl px-5 py-4">
                <p className="font-display text-base font-semibold text-slate-100">Vishal Behera</p>
                <p className="font-code text-[11px] text-amber-400/90 mt-0.5">Engineer × Builder × Entrepreneur</p>
              </div>
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHeader index="10" eyebrow="Behind The Code" title={about.heading} testId="about-header" />
          {about.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08}>
              <p className="text-sm sm:text-base text-slate-400 leading-relaxed mb-5">{p}</p>
            </Reveal>
          ))}

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {about.principles.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08}>
                <div className="rounded-2xl border border-white/[0.07] bg-[#0F1420] p-5 h-full" data-testid={`principle-${i}`}>
                  <p className="font-code text-[10px] uppercase tracking-[0.25em] text-amber-400/80">{String(i + 1).padStart(2, "0")}</p>
                  <h3 className="mt-2 font-display text-base font-semibold text-slate-100">{p.title}</h3>
                  <p className="mt-1.5 text-xs sm:text-sm text-slate-400 leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-2" data-testid="about-interests">
              {about.interests.map((t) => (
                <span key={t} className="rounded-full border border-white/10 px-3.5 py-1.5 text-xs text-slate-400">
                  {t}
                </span>
              ))}
            </div>
          </Reveal>

          {about.education && (
            <Reveal delay={0.25}>
              <div className="mt-6 flex items-center gap-4 rounded-2xl border border-white/[0.07] bg-[#0F1420] px-5 py-4" data-testid="about-education">
                <span className="shrink-0 rounded-lg border border-amber-400/25 bg-amber-400/10 px-2.5 py-1 font-code text-[10px] tracking-widest text-amber-400">EDU</span>
                <p className="text-sm text-slate-400">
                  {about.education.degree} · <span className="font-medium text-slate-100">{about.education.school}</span> · <span className="font-code text-xs text-slate-500">{about.education.years}</span>
                </p>
              </div>
            </Reveal>
          )}
        </div>
      </div>
    </div>
  </section>
);
